/**
 * Comment-related strings.
 */
import React from 'react';
import '../Comment/CommentCard.less';
import IconButton from '../ui/IconButton/IconButton';
import Icons from '../ui/IconButton/Icons';

export default {
    d_title: 'Private Discussion',
    h_title: <div>
        <h3>Overview</h3>
        <p>Private Discussions can be used for notes that you do not want in the client record.</p>
        <p>These could be status updates, or other notes that would help another user understand what is going on.</p>
        <p>Private discussions are available for all major pages (e.g. tasks, contacts, campaigns, leads and cases).</p>
        <h3>Related Discussions</h3>
        <p>The Private Discussion area will pull discussions from related areas into one spot. For example, if you are
            in a case, the Private Discussion area will include discussions from the case, tasks related to the case,
            the lead related to the case, and clients related to the case. If you are in a Contact, it will include
            discussions related to the contact, including tasks, leads and cases.</p>
        <p>It is easy to tell where a discussion originated based on the icons, formatting and title added to these
            messages. For example:</p>
        <div className='u-row'
             style={{
                 backgroundColor: 'mintcream',
                 boxShadow: '1px 1px 3px #8888',
                 padding: '5px',
                 borderRadius: '5px',
                 gap: '5px'
             }}>
            <IconButton type={Icons.SALES}
                        color='darkgreen'
                        style={{marginBottom: '2px'}}
            />
            <span><b>Will for Natasha Banks</b></span>
        </div>
    </div>,

    d_conversationUpdates: 'Conversation Updates',
    h_conversationUpdates: '<div><p>Show comments from private conversations anywhere in the system at a glance.</p><p>The list shows who made the comment, when, and what the commend was. It also shows a reference to where in the system the comment was made (a task, lead, case, etc.).</p><p>Use the slider to show older conversation updates.</p></div>'
};